/**
 * Krátký pokyn „do gitu“ má hned ukázat správu commitu, ne čekat na LLM.
 */

export type GitStatusFile = { status?: string; path?: string };

export type WorkspaceStatusLike = {
  ok?: boolean;
  dirty?: boolean;
  files?: GitStatusFile[];
  hint?: string;
  error?: string;
};

const INTENT_RE =
  /\b(do gitu|zapiš(?: to)? do gitu|zapsat do gitu|ulož(?:it)? do gitu|uloz(?:it)? do gitu|commitni(?: to)?|pushni(?: to)?|git commit|git push|commit and push)\b/i;
const BARE_RE = /^(commit|push|commitni|pushni)(?:\s+to)?[.!?]*$/i;
const QUESTION_RE = /\b(proč|proc|why|jak funguje|co je v|status|log|historie|history)\b/i;

export function isGitCommitIntent(text: string): boolean {
  const raw = text.trim();
  if (!raw || raw.length > 40) return false;
  const t = raw.replace(/\s+/g, ' ');
  if (QUESTION_RE.test(t)) return false;
  if (BARE_RE.test(t)) return true;
  return INTENT_RE.test(t);
}

export function suggestCommitMessage(
  files: GitStatusFile[] | undefined,
  fallback = 'WIP',
): string {
  const names = (files ?? [])
    .map((f) => String(f.path ?? '').trim())
    .filter(Boolean)
    .map((p) => p.split('/').pop() || p);
  if (names.length === 0) return fallback;
  if (names.length === 1) return `Změna ${names[0]}`;
  if (names.length <= 3) return `Změny: ${names.join(', ')}`;
  return `Změny: ${names[0]} a dalších ${names.length - 1}`;
}

export function formatCommitFence(status: WorkspaceStatusLike): string {
  if (!status.ok) {
    return status.error
      ? `Git status se nepodařilo načíst: ${status.error}`
      : 'Git status se nepodařilo načíst.';
  }
  const files = (status.files ?? []).filter((f) => f.path);
  if (!status.dirty || files.length === 0) {
    return 'Není co zapsat — working tree je čistý.';
  }
  const msg = suggestCommitMessage(files);
  const body = files
    .map((f) => `${String(f.status ?? '').trim() || 'M'} ${f.path}`.trim())
    .join('\n');
  const escaped = msg.replace(/"/g, "'");
  return `Připravený GitLab checkpoint. Zkontroluj zprávu a potvrď.\n\n\`\`\`commit "${escaped}"\n${body}\n\`\`\``;
}
